import { Button, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import knowledgeDocumentsService from "services/admin/KnowledgeDocumentsService";
import { toast } from "react-toastify";
import { KnowledgeDocumentList } from "./components/KnowledgeDocumentList";
import { useGetKnowledgeDocuments } from "hooks/useGetKnowledgeDocuments";
import PageGuide from "components/PageGuide/PageGuide";

export const KnowledgeDocuments = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { data, isLoading, refetch } = useGetKnowledgeDocuments();

  const handleUploadDocument = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsSubmitting(true);
    try {
      const file = e.target.files?.[0];
      if (file) {
        console.log("file", file);
        const response = await knowledgeDocumentsService.post({ file }, {}, true);
        console.log("response", response.data);
        toast.success("Документ загружен успешно");

        refetch();
      }
    } catch (error) {
      console.error(error);
      toast.error("Ошибка при загрузке документа");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async (id: number) => {
    try {
      if (window.confirm("Вы уверены, что хотите удалить документ?")) {
        await knowledgeDocumentsService.delete(id);
        toast.success("Документ удален успешно");
        refetch();
      }
    } catch (error) {
      console.error(error);
      toast.error("Ошибка при удалении документа");
    }
  };

  return (
    <div>
      <h1>База знаний</h1>
      <PageGuide id="knowledge-documents" title="Зачем нужна база знаний" className="mt-4">
        <p className="mb-2">
          Загрузите документы, из которых агент будет брать ответы: прайс-лист, условия доставки и оплаты,
          описание услуг, частые вопросы. Перед ответом агент находит в них подходящий фрагмент.
        </p>
        <p>Лучше несколько коротких документов по темам, чем один огромный. После загрузки проверьте агента в «Тестовой среде».</p>
      </PageGuide>

      {isLoading ? (
        <CircularProgress />
      ) : (
        <div className="flex flex-col gap-2 mb-8 border rounded-md p-16">
          <input type="file" onChange={handleUploadDocument} />
        </div>
      )}

      <KnowledgeDocumentList data={data} handleDelete={handleDelete} />
    </div>
  );
};
